import { render, staticRenderFns } from "./ShopCardUse.vue?vue&type=template&id=3b8da274&scoped=true"
import script from "./ShopCardUse.vue?vue&type=script&lang=js"
export * from "./ShopCardUse.vue?vue&type=script&lang=js"
import style0 from "./ShopCardUse.vue?vue&type=style&index=0&id=3b8da274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8da274",
  null
  
)

export default component.exports